/* oxlint-disable no-console */
import React from 'react';
import { JSONTree } from 'react-json-tree';

import type { ValidationError } from './../../../ricos-schema/next-schema/index.js';
import { validateRicosDocument } from './../../../ricos-schema/next-schema/index.js';

import { Button } from '../components/Button.js';
import { jsonTreeTheme } from '../theme.js';

type Props = {
  content: any;
};

export const RichContentTree: React.FC<Props> = ({ content }) => {
  const errors = React.useMemo(() => {
    const validationResult = validateRicosDocument(content);
    return validationResult.type === 'ok' ? [] : validationResult.errors;
  }, [content]);
  const hasErrorUnder = isErrorUnderNode(errors);
  const getErrorFor = getErrorForNode(errors);
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        {errors.length ? (
          <Button
            style={{ border: '1px solid red', marginRight: '10px' }}
            onClick={() => {
              console.log(errors);
            }}
          >
            Log Errors
          </Button>
        ) : null}
        <Button
          onClick={() => {
            navigator.clipboard.writeText(JSON.stringify(content));
          }}
          style={{ marginRight: '10px' }}
        >
          Copy into clipboard
        </Button>
        <Button
          onClick={() => {
            // oxlint-disable-next-line no-console
            console.log(content);
          }}
        >
          Log to console
        </Button>
      </div>
      <JSONTree
        valueRenderer={(valueAsString, _value, ...nodePath) => {
          const error = getErrorFor(nodePath);
          if (error) {
            return (
              <span style={{ color: 'red' }}>
                {valueAsString} [Error: {error.message}]
              </span>
            );
          }

          return valueAsString;
        }}
        getItemString={(type, value, defaultView, keysCount, nodePath) => {
          const error = getErrorFor(nodePath);
          const hasError = hasErrorUnder(nodePath);
          if (error) {
            return (
              <span>
                {defaultView} {keysCount} <span style={{ color: 'red' }}>{error.message}</span>
              </span>
            );
          }
          if (type === 'Object' && value.type) {
            return (
              <span style={hasError ? { color: 'red' } : {}}>
                {'{} '}
                {value.type}
              </span>
            );
          }

          return (
            <span style={hasError ? { color: 'red' } : {}}>
              {defaultView} {keysCount}
            </span>
          );
        }}
        data={content}
        invertTheme={false}
        theme={jsonTreeTheme}
        hideRoot
        shouldExpandNode={hasErrorUnder}
      />
    </div>
  );
};

const getErrorForNode =
  (errors: ValidationError[]) =>
  (nodePath: (string | number)[]): ValidationError | undefined => {
    if (!errors.length) {
      return;
    }
    const nodePathAsPointer = [...nodePath].reverse().map(p => p.toString());
    return errors.find(({ instancePath }) => {
      return (
        instancePath.length === nodePathAsPointer.length &&
        instancePath.every((p, i) => p === nodePathAsPointer[i])
      );
    });
  };

const isErrorUnderNode =
  (errors: ValidationError[]) =>
  (nodePath: (string | number)[]): boolean => {
    if (!errors.length) {
      return false;
    }
    const nodePathAsPointer = [...nodePath].reverse().map(p => p.toString());
    return !!errors.find(({ instancePath }) => {
      return nodePathAsPointer.every((p, i) => instancePath[i] === p);
    });
  };
